import React from 'react'

const Facility = ({ facility, heading, description }) => {
    return (
        <div className='flex flex-col mb-6 justify-center'>
            <img className='w-[78px] h-[72px] md:w-[91px] md:h-[84px] lg:w-[104px] lg:h-[96px] rounded mb-4' src={require(`../../assets/icon-facility${facility}.png`)} alt={`facility-${facility}`} />
            <div className='text-left'>
                <h3 className='font-bold text-lg md:text-xl lg:text-2xl'>{heading}</h3>
                <p className='text-sm text-[#71717A] md:text-lg lg:text-xl'>{description}</p>
            </div>
        </div>
    )
}

export default Facility